function formatterCalculatorHtml(text: string, name: string): string | null {
  const regex = /.com.br\/(\w+)/;
  const result = regex.exec(text);
  if (!result) {
    return null;
  }
  const sku = result[1];
  return `<span href="/calculadoras/${sku.replace('calculadora_', '')}" target="_parent" style="text-decoration: underline; color: #593ABC; font-weight: bold;">${name}</span>`;
}
export default formatterCalculatorHtml;
